import * as React from 'react';
import { Route, Link, withRouter, Redirect } from 'react-router-dom';
import * as classNames from 'classnames';

import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import { Login } from './Login';
import { DiscussionBoard } from './DiscussionBoard';

import * as ForumActionCreators from "../../actions/forum.actions";
import * as LoginActionCreators from "../../actions/login.actions";
import * as MembersActionCreators from "../../actions/members.actions";
import * as ResourcesActionCreators from "../../actions/resources.actions";
import * as Config from '../../configuration/consts';

const queryString = require('query-string');

@withRouter
class Container extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.props.validate();
        var queryStringParam = queryString.parse(this.props.location.search);
        this.state = { forumId: queryStringParam.id, role: undefined};
    }

    componentDidMount(){
        if(this.state.forumId){
            this.props.getForumRequest(this.state.forumId, true);
        }
    }

    componentDidUpdate(prevProps, prepState){
        var queryStringParam = queryString.parse(this.props.location.search);

        // If there is no active forum
        if(prevProps.forum && !this.props.forum && queryStringParam.id){
            this.props.history.push('/DiscussionBoard');
        } else {
            // If logged in and forum has changed, update permission
            if(this.props.currentUser && this.props.forum){
                var memberRole = this.props.currentUser.forumPermissions[0] ? Config.ROLE_ADMIN : this.props.currentUser.forumPermissions[this.props.forum.id];
                if(memberRole != this.state.role){
                    this.setState({ role: memberRole });
                }
            } else if(this.props.currentUser){
                var memberRole = this.props.currentUser.forumPermissions[0];
                if(memberRole != this.state.role){
                    this.setState({ role: memberRole });
                }
            }
        }
    }

    render() {
        return (
            <Redirect to="/" />
        );
        const { currentUser, forum, login, ...props } = this.props;

        let content = !currentUser ? <Login login={login} {...this.props}/> : 
                                    <DiscussionBoard userRole={this.state.role} {...this.props}/>;
        
        let boardListActive = this.props.activeTab == Config.SHOW_BOARDS|| !forum;  
        let title = boardListActive || !forum ? "Member Area" : forum.title;
        let theme = undefined;
        let themeColour = undefined;   
        return (
            <div id="SectionContainer">
                <section className="content">
                    <div className="container discussion-board">
                        <div className="row">
                            <div className={classNames("col-12", {"base1-bg": boardListActive})} >
                                <h1 className={classNames({"text-center": boardListActive, "text-left": !boardListActive})} dangerouslySetInnerHTML={{ __html: title }}></h1>
                            </div>
                        </div>
                        {content}
                        
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authUser: state.discussionBoard.authUser,
        currentUser: state.discussionBoard.currentUser,
        forum: state.discussionBoard.forum,
        forums: state.discussionBoard.forums,
        activeTab: state.discussionBoard.activeTab,
        singlePostView: state.discussionBoard.singlePostView,
        currentUsersForums: state.discussionBoard.forums,
        forumLoading: state.discussionBoard.forumLoading,
        error: state.discussionBoard.error,
        search: state.discussionBoard.search,
        editingForum: state.discussionBoard.editingForum
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            login: LoginActionCreators.loginRequest,
            resetPassword: LoginActionCreators.resetPasswordRequest,
            resetPasswordUpdate: LoginActionCreators.resetPasswordUpdateRequest,
            validate: LoginActionCreators.loginValidate,
            getCurrentUser: LoginActionCreators.getCurrentUserRequest,
            logout: LoginActionCreators.logoutRequest,

            switchForum: ForumActionCreators.switchForum,
            searchRequest: ForumActionCreators.searchRequest,

            saveForum: ForumActionCreators.saveForumRequest,
            editForum: ForumActionCreators.editForum,
            clearForum: ForumActionCreators.clearForum,
            refreshForumData: ForumActionCreators.getForumDataRequest,
            getForumRequest: ForumActionCreators.getForumRequest,
            getForumUpdateRequest: ForumActionCreators.getForumUpdateRequest,
            getForumListRequest: ForumActionCreators.getForumListRequest,
            subscribeForum: ForumActionCreators.subscribeForumRequest,

            getMember: MembersActionCreators.getMemberRequest,
            saveUser: MembersActionCreators.saveMemberRequest,
            editUser: MembersActionCreators.editUser,
            clearUser: MembersActionCreators.clearUser,
            searchUsers: MembersActionCreators.searchMemberRequest,
            updateNotification: MembersActionCreators.setNotificationRequest,
            updateEmailFrequency: MembersActionCreators.setUpdateFrequencyRequest,

            changeActiveTab: ForumActionCreators.changeActiveTab,
            loadPost: ForumActionCreators.loadPostRequest,
            savePost: ForumActionCreators.savePostRequest,
            savePostReaction: ForumActionCreators.saveForumPostReactionRequest,
            addPostTag: ForumActionCreators.savePostTagRequest,
            searchPosts: ForumActionCreators.searchPostRequest,
            followPost: ForumActionCreators.followPostRequest,

            saveTagRequest: ForumActionCreators.saveTagRequest,
            activeTag: ForumActionCreators.activeTag,

            saveResource: ResourcesActionCreators.saveResourceRequest,
            flagResource: ResourcesActionCreators.flagResourceRequest,
            editResource: ResourcesActionCreators.editResource,
            clearResource: ResourcesActionCreators.clearResource,
            searchResources: ResourcesActionCreators.searchResourceRequest,
            addResourceTag: ResourcesActionCreators.saveResourceTagRequest,
            sortResourceItem: ResourcesActionCreators.sortResourceRequest,
        },
        dispatch
    );
};


const DiscussionBoardContainer = connect(mapStateToProps, mapDispatchToProps)(
    Container
);

export default DiscussionBoardContainer;


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Container.tsx